import { z } from 'zod';

export const JOB_APPLICATION_STATUSES = [
  'received',
  'under_review',
  'shortlisted',
  'rejected',
  'hired',
] as const;
export const jobApplicationStatusEnum = z.enum(JOB_APPLICATION_STATUSES);
export type JobApplicationStatus = z.infer<typeof jobApplicationStatusEnum>;

/**
 * Careers "apply now" form payload. The résumé file itself travels as a
 * multipart upload (handled by multer + the server's StorageProvider, not
 * Zod) — this schema covers the accompanying text fields, which multer
 * places on `req.body` alongside the file.
 */
export const createJobApplicationSchema = z.object({
  fullName: z.string().trim().min(2, 'Name must be at least 2 characters').max(120),
  email: z.string().trim().toLowerCase().email('Enter a valid email address'),
  phone: z
    .string()
    .trim()
    .regex(/^[+\d][\d\s()-]{6,19}$/, 'Enter a valid phone number')
    .optional()
    .or(z.literal('')),
  positionTitle: z.string().trim().min(2).max(160),
  linkedinUrl: z.string().trim().url('Enter a valid URL').optional().or(z.literal('')),
  portfolioUrl: z.string().trim().url('Enter a valid URL').optional().or(z.literal('')),
  coverMessage: z.string().trim().max(2000).optional().or(z.literal('')),
});

export type CreateJobApplicationInput = z.infer<typeof createJobApplicationSchema>;

export const updateJobApplicationStatusSchema = z.object({
  status: jobApplicationStatusEnum,
});

export type UpdateJobApplicationStatusInput = z.infer<typeof updateJobApplicationStatusSchema>;

export const jobApplicationListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  status: jobApplicationStatusEnum.optional(),
});

export type JobApplicationListQuery = z.infer<typeof jobApplicationListQuerySchema>;
